import { Button } from '@winnin/winnin_ui.components.button'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './confirm-niche-action.i18n'
import type { IConfirmNicheAction } from './confirm-niche-action.types'
import './confirm-niche-action.styles.scss'

export const ConfirmNicheActionView = ({ handleClose, handleConfirm, isButtonDisabled }: IConfirmNicheAction) => {
  return (
    <div className="ConfirmNicheAction">
      <div className="descriptionText">
        <T keyName={translations.descriptionText.key}>{translations.descriptionText.defaultValue}</T>
      </div>
      <div className="confirmationText">
        <T keyName={translations.confirmText.key}>{translations.confirmText.defaultValue}</T>
      </div>
      <div className="buttonsSection">
        <Button appearance="link" onClick={handleClose}>
          <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
        </Button>
        <Button onClick={handleConfirm} disabled={isButtonDisabled}>
          <T keyName={TOLGEE_GLOBALS.confirm.key}>{TOLGEE_GLOBALS.confirm.defaultValue}</T>
        </Button>
      </div>
    </div>
  )
}
